class Popover {
	constructor() {
		this.$triggers = $('.js-popover-btn');
		this.$popovers = $('.popover');
	}

	init() {
		this.$triggers.on('click', function (e) {
			e.stopPropagation();
			e.preventDefault();

			const href = $(this).attr('href');
			if ($(href).length) {
				$(href).addClass('is-active');
			}
		});

		this.$popovers.on('click', (e) => {
			e.stopPropagation();
		});

		$(document).on('click', () => {
			this.$popovers.removeClass('is-active');
		});

		$('.popover__close').on('click', () => {
			this.$popovers.removeClass('is-active');
		});
	}
}

export default Popover;
